import React, { Fragment, useCallback } from 'lib/react';
import {
  EVClickAwayListener,
  EVPopper,
} from 'lib/components';
import PropTypes from 'prop-types';

function Popper(props) {
  const {
    children, popperId, open, onClickAway, anchorEl, disableResize, ...rest
  } = props;

  const Wrapper = onClickAway ? EVClickAwayListener : Fragment;
  const wrapperProps = onClickAway ? { onClickAway } : {};

  // Fix for incorrect popper position when popper content size changes
  const popperRef = useCallback((popperInstance) => {
    if (popperInstance && !disableResize) {
      const resizeObserver = new ResizeObserver(() => popperInstance.update());
      resizeObserver.observe(popperInstance.popper);
    }
  }, []);

  return (
    <EVPopper
      id={popperId}
      anchorEl={anchorEl}
      open={open}
      popperRef={popperRef}
      {...rest}
    >
      <Wrapper {...wrapperProps}>
        {children}
      </Wrapper>
    </EVPopper>
  );
}

Popper.defaultProps = {
  onClickAway: null,
  anchorEl: null,
  disableResize: false,
};

Popper.propTypes = {
  // #genai declare the already-required children prop; every call site passes popper content
  children: PropTypes.node.isRequired,
  disableResize: PropTypes.bool,
  popperId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClickAway: PropTypes.func,
  anchorEl: PropTypes.instanceOf(Element),
};

export default Popper;
